import { render, staticRenderFns } from "./HookInfoAdd.vue?vue&type=template&id=1910460f&scoped=true&"
import script from "./HookInfoAdd.vue?vue&type=script&lang=js&"
export * from "./HookInfoAdd.vue?vue&type=script&lang=js&"
import style0 from "./HookInfoAdd.vue?vue&type=style&index=0&id=1910460f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1910460f",
  null
  
)

export default component.exports